import {z} from '@hono/zod-openapi';

import {priceReportArgumentsLocaleSchema} from './PriceReportArgumentsLocaleSchema';
import {priceReportSourceSchema} from './PriceReportSourceSchema';

export const priceReportArgumentsQuerySchema = z
  .object({
    locale: priceReportArgumentsLocaleSchema.openapi({param: {name: 'locale', in: 'query'}}),
    // Only a FAILED result is regenerated; a completed one is always served from storage.
    regenerate: z
      .enum(['true', 'false'])
      .optional()
      .openapi({param: {name: 'regenerate', in: 'query'}}),
    // Clients older than this parameter omit it and read Metada.
    // Inline enum: a $ref parameter loses its default in the OpenAPI doc.
    source: z
      .enum(priceReportSourceSchema.options)
      .default('metada')
      .openapi({param: {name: 'source', in: 'query'}}),
  })
  .openapi('PriceReportArgumentsQuery');
